import { render, staticRenderFns } from "./VxSpinner.vue?vue&type=template&id=620f0b3d&scoped=true&lang=html"
import script from "./VxSpinner.vue?vue&type=script&lang=js"
export * from "./VxSpinner.vue?vue&type=script&lang=js"
import style0 from "./VxSpinner.vue?vue&type=style&index=0&id=620f0b3d&prod&scoped=true&lang=css"
import style1 from "./VxSpinner.vue?vue&type=style&index=1&id=620f0b3d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f0b3d",
  null
  
)

export default component.exports